<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :validations="validations.cabecaPescoco"
                    label="Cabeça e pescoço"
                    v-model="data.model.avaliacaoCabecaPescoco.avaliacaoCabecaPescoco"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :validations="validations.torax"
                    label="Tórax"
                    v-model="data.model.avaliacaoTorax"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :validations="validations.abdome"
                    label="Abdome"
                    v-model="data.model.avaliacaoAbdome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :validations="validations.mmssmmii"
                    label="MMSS e MMII"
                    v-model="data.model.avaliacaoMmssMmii"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :validations="validations.observacao"
                    label="Observações"
                    v-model="data.model.observacao"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import RkmFormIncrementalTextarea from '@/components/pronto-atendimento/components/base/FormIncrementalTextarea'

export default {
    components: { RkmFormIncrementalTextarea },
    computed: {
        validations() {
            return {
                cabecaPescoco: { max: 3000 },
                torax: { max: 3000 },
                abdome: { max: 3000 },
                mmssmmii: { max: 3000 },
                observacoes: { max: 3000 },
            }
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>